import { getSizeById } from 'constants/targets';
import SvgToIllustrator from './SvgToIllustrator';
/**
 * make necessary style adjustment to the svg string
 * @param {string} full - outer and inner chart svgs
 * @return {string}  ready for AI svg string
 */


export const getSvgData = (svgStr, isVideo) => {
  // apply fill for outer chart background and plot-background
  const fullWithBg = svgStr
    .replace(/"highcharts-background"/, `"highcharts-background" fill="#${isVideo ? '222': 'fff'}"`)
    .replace(/"highcharts-plot-background"/, '"highcharts-plot-background" fill="none"');

  const endInnerIdx = fullWithBg.indexOf('</svg>');
  const endOuter = fullWithBg.slice(endInnerIdx);
  // set fill to outer chart highcharts-plot-border
  const endReplaced = endOuter.replace(/"highcharts-plot-border"/, '"highcharts-plot-border" fill="none"');
  const fullWithAttrs = fullWithBg.slice(0, endInnerIdx) + endReplaced;
  const final = fullWithAttrs.replace(/rgba\(0, 0, 0, 0\)/g, 'none');
  return final;
};



export const exportSvgNewEnginePrint = (highchart, filename) => {
  highchart.exportChart({
    type: 'image/svg+xml',
    filename,
  });
};

export const getPrintSvgData = (id, highchart) => {
  const highchartSvg = highchart.getSVG();
  const parser = new DOMParser();
  const svg = parser.parseFromString(highchartSvg, "image/svg+xml").querySelector('svg');
  const size = getSizeById(id);
  const convertedSvg = SvgToIllustrator.convert(svg, size, true);
  return convertedSvg;
}
